import React, { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';

import copyToClipboard from 'utils/clipboard';

import {
  Wrapper,
  PromptText,
  LeftContent,
  CopyButton,
  CopyButtonText,
  CopyIcon
} from './styled';

const COPY_STATUS_LABELS = {
  copied: 'Copied',
  error: 'Copy failed'
};

const PromptCopyCard = ({
  text,
  copyValue,
  leadingIcon,
  className
}) => {
  const [copyStatus, setCopyStatus] = useState(null);
  const resetTimeoutRef = useRef(null);
  const isMountedRef = useRef(true);

  useEffect(() => () => {
    isMountedRef.current = false;
    clearTimeout(resetTimeoutRef.current);
  }, []);

  const handleCopy = () => {
    const clipboardValue = copyValue || (typeof text === 'string' ? text : '');

    clearTimeout(resetTimeoutRef.current);

    copyToClipboard(clipboardValue)
      .then(() => { if (isMountedRef.current) setCopyStatus('copied'); })
      .catch(() => { if (isMountedRef.current) setCopyStatus('error'); })
      .finally(() => {
        if (isMountedRef.current) {
          resetTimeoutRef.current = window.setTimeout(() => setCopyStatus(null), 1500);
        }
      });
  };

  return (
    <Wrapper className={ className }>
      <LeftContent>
        {leadingIcon}
        <PromptText>{text}</PromptText>
      </LeftContent>
      <CopyButton onClick={ handleCopy } type="button">
        <CopyButtonText $isError={ copyStatus === 'error' }>
          {COPY_STATUS_LABELS[copyStatus] || 'Copy'}
        </CopyButtonText>
        <CopyIcon />
      </CopyButton>
    </Wrapper>
  );
};

PromptCopyCard.propTypes = {
  text: PropTypes.node.isRequired,
  copyValue: PropTypes.string,
  leadingIcon: PropTypes.node,
  className: PropTypes.string
};

PromptCopyCard.defaultProps = {
  copyValue: '',
  leadingIcon: null,
  className: ''
};

export default PromptCopyCard;
